import React from 'react';
import Head from 'next/head';

import { commercialFilters as defaultFilters } from '../../../helper/filters';

import NevoVechicleSearch from '../../../components/VehicleSearch/Nevo';

import SearchPageCommercial from '../../../public/assets/images/headers/commercials-header.jpg';

export default function CommercialVehiclesPage() {
  return (
    <>
      <Head>
        <title>Commercial Vehicles | Nevo</title>
      </Head>

      <NevoVechicleSearch
        defaultFilters={defaultFilters}
        backgroundImg={SearchPageCommercial.src}
        commercial
      />
    </>
  )
}
